const Style = {

  base: 'py-10 md:py-14 px-0 text-left bg-surface',
  transparent: 'bg-transparent',
  tint: 'bg-muted',
  dark: 'bg-primary-900 text-white',
  brand: 'bg-primary-600 text-white',
  left: 'text-left',
  center: 'text-center',
  
}

export default Style;